export default __webpack_public_path__ + "static/media/QI-Toolkits.1e3e920b.jpeg";